var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Breadcrumb',{attrs:{"name":"聯絡我們"}}),_c('Subtitle',{attrs:{"subtitle":"聯絡我們"}}),_c('ContactUsInfo'),_c('ContactUsForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }